import { render } from "./ShiftTableComponent.vue?vue&type=template&id=a6b1f7bc"
import script from "./ShiftTableComponent.vue?vue&type=script&lang=js"
export * from "./ShiftTableComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__